import { AsyncPipe, DOCUMENT, isPlatformBrowser, Location, NgClass, NgStyle } from '@angular/common';
import { AfterViewInit, Component, Inject, LOCALE_ID, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { StoreConfigService } from '@scalefast/config-angular';
import { LoginService, SubscribeNewsletterService } from '@scalefast/ecommerce-core';
import { Observable, Subscription } from 'rxjs';
import { AnalyticsStoreService, FooterLinksService, PohService } from '../../services';
import { AppPaymentMethodsComponent } from '../payment-methods/payment-methods.component';
import { AppSubscribeNewsletterModalComponent } from '../subscribe-newsletter-modal/subscribe-newsletter-modal.component';
import { AppSubscribeNewsletterCoreComponent } from '../subscribe-newsletter/subscribe-newsletter-core.component';
import { NewsletterService } from '../../services/newsletter.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    AppSubscribeNewsletterCoreComponent,
    NgClass,
    NgStyle,
    AppPaymentMethodsComponent,
    AppSubscribeNewsletterModalComponent,
    AsyncPipe,
  ],
})
export class AppFooterComponent implements OnInit, AfterViewInit, OnDestroy {
  localeId: string;
  loginUrl: string;
  accountUrl: string;
  isLogged$: Observable<boolean>;

  footerLinks: any = {};
  currentYear: number | null = null;
  titleHeight: number | undefined;
  titleheights: number[] = [];
  localIdLowerCase: string;
  isPohPage: boolean = false;
  isAPohPdp: boolean = false;
  showNewsletter: boolean = false;
  pohServiceSubscription: Subscription | undefined;
  pohPdpServiceSubscription: Subscription | undefined;
  // The title of the opened dropdown, used to check if any dropdown is open
  openDropdownTitle = signal('');

  constructor(
    private loginService: LoginService,
    private storeConfigService: StoreConfigService,
    private subscribeNewsletterService: SubscribeNewsletterService,
    private newsletterService: NewsletterService,
    private footerLinksService: FooterLinksService,
    private analyticsStoreService: AnalyticsStoreService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public location: Location,
    private pohService: PohService,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(DOCUMENT) private _doc: Document,
  ) {
    this.localeId = this.locale;
    this.localIdLowerCase = this.localeId.toLowerCase();
    this.loginUrl = this.storeConfigService.getCustomRoutes()?.login ?? 'sso_login';
    this.accountUrl = this.storeConfigService.getCustomRoutes()?.account ?? 'account';
    this.footerLinks = this.footerLinksService.getFooterLinks();
    this.isLogged$ = this.loginService.isLogged();
  }

  openDropdown(title: string): void {
    this.openDropdownTitle.update((t) => (t === title ? '' : title));
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();

    this.newsletterService.showNewsletter$.subscribe((value) => (this.showNewsletter = value));

    this.pohServiceSubscription = this.pohService.isAPohPage(true).subscribe((isPohPage) => {
      this.isPohPage = isPohPage;
    });

    this.pohPdpServiceSubscription = this.pohService.isAPohProductPage().subscribe((res) => (this.isAPohPdp = res));
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const titles = this._doc.querySelectorAll('.dropdown-toggle.footer-links__title');

      const titleObserver = new ResizeObserver((entries) => {
        entries.forEach((entry: any, i: number) => {
          this.setTitleHeight(entry.contentRect.height, i);
        });
      });

      if (titles) {
        titles.forEach((title) => {
          titleObserver.observe(title);
        });
      }
    }
  }

  setTitleHeight(h: number, i: number) {
    if (h > 0)
      if (!this.titleheights[i]) {
        this.titleheights.push(h);
      } else {
        this.titleheights[i] = h;
      }
    this.titleHeight = Math.max(...this.titleheights);
  }

  gtmEvent(event: any): void {
    const category = event.currentTarget.getAttribute('data-gtmcategory');
    const action = event.currentTarget.getAttribute('data-gtmaction');
    const label = event.currentTarget.getAttribute('data-gtmlabel');
    this.analyticsStoreService.miscEvent(category, action, label);
  }

  ngOnDestroy(): void {
    this.pohServiceSubscription?.unsubscribe();
    this.pohPdpServiceSubscription?.unsubscribe();
  }
}
